module.exports = __webpack_public_path__ + "static/media/somaiya-vidyavihar-brand.9a63230b.svg";